var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "a-card",
        { attrs: { title: _vm.$t("lbl_invoice_recurring_report") } },
        [
          _c(
            "a-form-model",
            {
              ref: "formModel",
              attrs: {
                model: _vm.form,
                "wrapper-col": { span: 12 },
                "label-col": { span: 6 },
                "label-align": "left",
                "data-testid": "inv-recurring-form",
                rules: _vm.validationSchema
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: [16, 16] } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_period_date"),
                            prop: "billingDate"
                          }
                        },
                        [
                          _c("a-range-picker", {
                            attrs: {
                              format: _vm.DEFAULT_DATE_FORMAT,
                              placeholder: [
                                _vm.$t("lbl_start_date"),
                                _vm.$t("lbl_end_date")
                              ],
                              "data-testid": "inv-recurring-date"
                            },
                            model: {
                              value: _vm.form.billingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "billingDate", $$v)
                              },
                              expression: "form.billingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: { label: _vm.$t("lbl_branch"), prop: "branch" }
                        },
                        [
                          _c("SelectBranch", {
                            attrs: {
                              "label-in-value": "",
                              "data-testid": "inv-recurring-branch"
                            },
                            model: {
                              value: _vm.form.branch,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "branch", $$v)
                              },
                              expression: "form.branch"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_customer"),
                            prop: "customer"
                          }
                        },
                        [
                          _c("SelectCustomer", {
                            attrs: {
                              "label-in-value": "",
                              "data-testid": "inv-recurring-customer"
                            },
                            model: {
                              value: _vm.form.customer,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customer", $$v)
                              },
                              expression: "form.customer"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_ar_invoice_number"),
                            prop: "invoiceArNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t("common.insert-text", {
                                text: _vm.$t("lbl_ar_invoice_number")
                              }),
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.form.invoiceArNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "invoiceArNo", $$v)
                              },
                              expression: "form.invoiceArNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_unit_code"),
                            prop: "unitCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "allow-clear": "",
                              placeholder: _vm.$t("common.insert-text", {
                                text: _vm.$t("lbl_unit_code")
                              }),
                              "data-testid": "inv-recurring-unit-code"
                            },
                            model: {
                              value: _vm.form.unitCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "unitCode", $$v)
                              },
                              expression: "form.unitCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_internal_contract_no"),
                            "label-align": "right",
                            prop: "icNo"
                          }
                        },
                        [
                          _c("SelectIcNumber", {
                            attrs: {
                              "branch-id": _vm.form.branch
                                ? _vm.form.branch.key
                                : undefined,
                              "customer-id": _vm.form.customer
                                ? _vm.form.customer.key
                                : undefined,
                              "data-testid": "inv-recurring-internal-contract",
                              "allow-clear": true
                            },
                            model: {
                              value: _vm.form.icNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "icNo", $$v)
                              },
                              expression: "form.icNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_invoice_ar"),
                            "label-align": "right",
                            prop: "invoiceAr"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.invoiceArOptions,
                              placeholder: _vm.$t("common.select-text", {
                                text: _vm.$t("lbl_invoice_ar")
                              }),
                              "allow-clear": "",
                              "data-testid": "inv-recurring-invoice-ar"
                            },
                            model: {
                              value: _vm.form.invoiceAr,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "invoiceAr", $$v)
                              },
                              expression: "form.invoiceAr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_by_backup_unit"),
                            "label-align": "right",
                            prop: "isBackup"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.booleanOptions,
                              placeholder: _vm.$t("common.select-text", {
                                text: _vm.$t("lbl_by_backup_unit")
                              }),
                              "allow-clear": "",
                              "data-testid": "inv-recurring-by-backup-unit"
                            },
                            model: {
                              value: _vm.form.isBackup,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "isBackup", $$v)
                              },
                              expression: "form.isBackup"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_internal_contract_status"),
                            "label-align": "right",
                            prop: "icStatus"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("common.select-text", {
                                  text: _vm.$t("lbl_internal_contract_status")
                                }),
                                allowClear: true,
                                "show-search": "",
                                loading: _vm.loading.status,
                                "option-filter-prop": "children",
                                "filter-option": _vm.filterOption
                              },
                              model: {
                                value: _vm.form.icStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "icStatus", $$v)
                                },
                                expression: "form.icStatus"
                              }
                            },
                            _vm._l(_vm.dataListStatus, function(data, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: data.value } },
                                [
                                  _c(
                                    "a-tooltip",
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" " + _vm._s(data.value) + " ")
                                      ]),
                                      _vm._v(" " + _vm._s(data.value) + " ")
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { attrs: { gutter: [16, 16] } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-space",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                "data-testid": "inv-recurring-btn-reset"
                              },
                              on: { click: _vm.handleReset }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("lbl_reset")) + " ")]
                          ),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                "data-testid": "inv-recurring-find",
                                type: "primary",
                                loading: _vm.loading.find,
                                "html-type": "submit"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("lbl_find")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("InvoiceRecurringReportTable", {
            attrs: {
              loading: _vm.loading.find,
              "invoice-recurring-reports": _vm.invoiceRecurringReports
            }
          }),
          _c(
            "div",
            { staticClass: "mt-2 text-right" },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading.download,
                    "data-testid": "inv-recurring-download"
                  },
                  on: { click: _vm.handleDownload }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_download")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }